import {DateAsString} from '@/common/api/api-raw-types';
import {nl2br} from '@malt/common';
import {da} from 'date-fns/locale';

export const FormatHelper = {
    dateToSimpleDateString: (date: Date): string => {
        return Intl.DateTimeFormat().format(date);
    },
    textToHtmlFormattedText: (text: string): string => {
        return nl2br(text);
    },
};
